import React from "react";
import { RaisedButton, Popover, Menu, MenuItem } from "material-ui";
import qs from "qs";

import InfoIcon from "material-ui/svg-icons/action/info";

import UserStore from "../../stores/UserStore";
import WatchUtil from "../../utils/WatchUtil";
import config from "../../config";

class ViewLiveVirtualButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      infoHovered: false,
      open: false,
      anchorEl: null
    };

    this._onClick = this._onClick.bind(this);
    this._onClose = this._onClose.bind(this);
    this.view = this.view.bind(this);
  }

  _onClick(e) {
    e.preventDefault();

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  }

  _onClose() {
    this.setState({ open: false });
  }

  view(adminPreview) {
    if (!adminPreview) {
      window.open(
        `${this.props.href}${
          this.props.href.indexOf("?") !== -1 ? "&" : "?"
        }__admin_preview__=exit`,
        "_blank"
      );
      return;
    }

    const w = window.open("", "_blank");
    WatchUtil.adminPreviewOnSite(
      UserStore.getState().apiKey,
      !!this.props.godMode
    )
      .then(data => {
        w.location = `${this.props.href}${
          this.props.href.indexOf("?") !== -1 ? "&" : "?"
        }__admin_preview__=${btoa(JSON.stringify(data))}`;
        w.focus();
      })
      .catch(e => window.alert(`Failed to preview: ${e.message}`));
  }

  render() {
    let { style, label, href, godMode, ...rest } = this.props;

    return (
      <div style={Object.assign({ display: "inline-block" }, style)}>
        <RaisedButton label={label} onTouchTap={this._onClick} {...rest} />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this._onClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          targetOrigin={{ horizontal: "right", vertical: "top" }}
        >
          <Menu desktop={true}>
            <MenuItem
              primaryText="View as audience"
              onTouchTap={() => this.view(false)}
            />
            <MenuItem
              primaryText={
                <span>
                  View as admin preview{" "}
                  <a
                    href="https://help.eventive.org/en/articles/4502687-test-your-virtual-screenings-using-admin-preview-for-quality-assurance"
                    target="_blank"
                    onTouchTap={e => e.stopPropagation()}
                    onMouseEnter={() => this.setState({ infoHovered: true })}
                    onMouseLeave={() => this.setState({ infoHovered: false })}
                  >
                    <span
                      style={{
                        display: "inline-block",
                        backgroundColor: this.state.infoHovered
                          ? "#4ABFFF"
                          : "#0187d0",
                        transition: "background-color 0.1s ease-in-out",
                        color: "#fff",
                        textDecoration: "none",
                        height: 20,
                        width: 20,
                        minWidth: 20,
                        marginLeft: 5,
                        borderRadius: "100%",
                        fontWeight: "bold",
                        lineHeight: "20px",
                        textAlign: "center"
                      }}
                    >
                      ?
                    </span>
                  </a>
                </span>
              }
              onTouchTap={() => this.view(true)}
            />
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default ViewLiveVirtualButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/view-live-virtual-button.jsx